export const SiteFooter = () => (
  <footer className="border-t border-white/[0.06] py-8" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <p><span className="font-semibold text-slate-300">IdeaValidator360</span> · Validate • Visualise • Preview • Build • Fund</p>
      <p>Reference case studies are illustrative demos; figures should be re-verified with live research.</p>
      <p>© {new Date().getFullYear()} ideavalidator360.com</p>
    </div>
  </footer>
);
